module.exports = __webpack_public_path__ + "img/facebook.59a6c0a8.svg";